module.exports = __webpack_public_path__ + "img/mycardpoint.a1dca470.png";